export default {
  methods: {
    navigateTo(params) {
      this.$router.push({ name: params }).catch(() => {});
    }
  }
};
